export default __webpack_public_path__ + "static/media/foto4.1d7515e8.jpg";